// extracted by mini-css-extract-plugin
export default {"root":"ListTabs_root__6qbg5","tab":"ListTabs_tab__pu2MP","--active":"ListTabs_--active__mvFUM"};